import React, { Component, Fragment } from 'react';
import {
  Alert, Button, Spinner, Table,
} from 'react-bootstrap';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { groupSurveysByParent } from '../../Utils/groupSurveys';
import { getSurveyDisplayName } from '../../Utils/surveyDisplayName';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import LanguageContext from "../../Layout/LanguageContext";
import { pageDict } from "../../Languages/PageTranslations";

import { Form } from './Form';
import { Details } from './Details';
import { isPanelCountryByName } from './surveyConstants';

import { PageStatus } from 'enums';
import { Show } from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import moment from "moment/moment";
import { SurveysAPI, MasterDataAPI } from "../../API";
import { exportToExcel } from "../../Utils/ExportToExcel";
import ShowDataAccording2PageSize from '../ShowEntries/ShowEntries';
import PaginationNumbering from '../ShowEntries/Pagination';


const MODAL_TYPES = {
  NONE: 'NONE',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  DETAILS: 'DETAILS',
};

type State = {
  status: PageStatus,
  error: string | null,
  formType: string,
  data: any[],
  id?: string | null,
  filteredData: any[],
  filters: {
    dateRange: any,
    projectId: '',
    client: '',
    publishDate: '',
    expiryDate: '',
    surveyName: '',
    surveyType: '',
    projectname: '',
    pmName: '',
  },
  pageSize: any,
  currentPageNumber: any,
  loading: any,
  pmRespoOpts: any[],
  countryOpts: any[],
};

class SurveysComponent extends Component<any, any> {
  static contextType = LanguageContext;
  _isMounted = false;

  constructor(props) {
    super(props);
    // Pre-seed surveyType from the URL so deep-links from the PM Dashboard
    // status cards (e.g. /admin/surveys?surveyType=Open) land already filtered.
    // Whitelisted to the 5 known values; anything else is treated as no filter.
    const urlSurveyType = (() => {
      const allowed = ['Open', 'Hold', 'Test', 'Wait', 'Close'];
      const params = new URLSearchParams((props.location && props.location.search) || '');
      const v = params.get('surveyType') || '';
      return allowed.includes(v) ? v : '';
    })();
    console.log('[SURVEYS-MOUNT]', {
      search: (props.location && props.location.search) || '',
      urlSurveyType,
      pathname: props.location && props.location.pathname,
    });
    this.state = {
      status: PageStatus.None,
      error: null,
      formType: MODAL_TYPES.NONE,
      data: [],
      id: null,
      filteredData: [],
      filters: {
        dateRange: '',
        projectId: '',
        client: '',
        publishDate: '',
        expiryDate: '',
        surveyName: '',
        surveyType: urlSurveyType,
        projectname: '',
        pmName: '',
      },
      pageSize: 10,
      currentPageNumber: 1,
      totalResponseData: '',
      totalResponsePages: '',
      loading: false,
      pmRespoOpts: [],
      expandedParents: {},
    };
    this.fetchList = this.fetchList.bind(this);
  }

  toggleParent = (parentId: string) => {
    this.setState((prev) => ({
      expandedParents: {
        ...prev.expandedParents,
        [parentId]: !prev.expandedParents[parentId],
      },
    }));
  };

  componentDidMount() {
    this._isMounted = true;
    this.fetchList();
    this.fetchPmList();
    this.fetchCountryList();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchPmList(): Promise<void> {
    return Promise.resolve()
    .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Loading }) })
    .then(() => SurveysAPI.pmListAPI())
    .then((response) => {
        if (!this._isMounted) return;
        let pmRespo: any = response;
        let pmData = pmRespo.map((ele: any) => {
          let value = "";
          if (ele.basic_profile.firstName) {
            value += ele.basic_profile.firstName += ele.basic_profile.lastName ? " " : "";
          }
          if (ele.basic_profile.lastName) {
            value += ele.basic_profile.lastName;
          }
          return { label: value, value }
        });
        this.setState({ pmRespoOpts: pmData, status: PageStatus.Loaded });
      })
      .catch((error) => {
        if (this._isMounted) this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  fetchCountryList(): Promise<void> {
    return Promise.resolve()
        .then(() => MasterDataAPI.countryList('10000'))
        .then((countries: any) => {
            if (!this._isMounted) return;
            const options = countries.map(country => ({
                label: country.name,
                value: country.name,
            }));
            this.setState({ countryOpts: options });
        })
        .catch(err => console.error("Failed to fetch country list", err));
  }

  fetchList(silent = false): Promise<void> {
    const { pageSize, currentPageNumber, filters } = this.state;
    return Promise.resolve()
      .then(() => { if (this._isMounted && !silent) this.setState({ status: PageStatus.Loading }) })
      .then(() => SurveysAPI.getAll(pageSize, currentPageNumber, filters))
      .then((response) => {
        if (!this._isMounted) return;
        let responseData: any = response;
        this.setState({ data: responseData.data, filteredData: responseData.data, totalResponseData: responseData.totalCount, totalResponsePages: responseData.totalPage, status: PageStatus.Loaded });
      })
      .catch((error) => {
        if (this._isMounted) this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  isShowDetailModal(): boolean {
    return this.state.formType === MODAL_TYPES.DETAILS
      || this.state.formType === MODAL_TYPES.DELETE;
  }


  readSurveyTypeFromUrl = (search: string): string => {
    const allowed = ['Open', 'Hold', 'Test', 'Wait', 'Close'];
    const params = new URLSearchParams(search || '');
    const value = params.get('surveyType') || '';
    return allowed.includes(value) ? value : '';
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
    );
  };

  applyFilters = () => {
    const { publishDate, expiryDate } = this.state.filters;
    if (publishDate && expiryDate && new Date(expiryDate) < new Date(publishDate)) {
      Swal.fire({ icon: 'warning', title: 'Invalid Date Range', text: 'End date must be after start date.' });
      return;
    }
    if (this.state.currentPageNumber == 1) { this.fetchList(); return; }
    this.setState({ currentPageNumber: 1 });
  };

  clearFilter = async () => {
    await new Promise((resolve: any) =>
      this.setState({
        filters: {
          client: '',
          publishDate: '',
          projectId: '',
          expiryDate: '',
          surveyName: '',
          surveyType: '',
          dateRange: '',
          projectname: '',
          country: '',
          pmName: '',
        },
        pageSize: 10,
        currentPageNumber: 1,
        totalResponseData: '',
        totalResponsePages: ''
      }, resolve));
    this.fetchList();
  }

  async handleExport() {
    const { currentPageNumber, filters } = this.state;
    this.setState({ loading: true });
    try {
      const recievedData = await SurveysAPI.getAll('All', currentPageNumber, filters);
      exportToExcel(recievedData.data, 'surveys');
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handlePageSizeChange = (newValue: any) => { this.setState({ pageSize: newValue, currentPageNumber: 1 }); };
  handlePageNumberChange = (newValue: any) => { this.setState({ currentPageNumber: newValue }); };

  componentDidUpdate(prevProps: any, prevState: State) {
    if (prevState.pageSize !== this.state.pageSize || prevState.currentPageNumber !== this.state.currentPageNumber) { this.fetchList(); }
    if (prevProps.location && this.props.location && prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ currentPageNumber: 1, formType: MODAL_TYPES.NONE, id: null }, () => this.fetchList());
    }
    if (prevProps.selectedCountry !== this.props.selectedCountry) {
      this.setState({ currentPageNumber: 1 }, () => this.fetchList());
    }
    // In-app navigation that changes only ?surveyType= (e.g. PM Dashboard card
    // clicks while already on the Surveys route) keeps the same pathname, so
    // the pathname branch above doesn't fire. Re-apply the URL filter here.
    if (prevProps.location && this.props.location &&
        prevProps.location.search !== this.props.location.search) {
      const newSurveyType = this.readSurveyTypeFromUrl(this.props.location.search);
      this.setState(
        (prev) => ({
          filters: { ...prev.filters, surveyType: newSurveyType },
          currentPageNumber: 1,
        }),
        () => this.fetchList()
      );
    }
  };

  render() {
    const { filters, pageSize, currentPageNumber, totalResponseData, totalResponsePages } = this.state;
    const lang = this.context || 'en';
    const t = (key) => (pageDict[lang] && pageDict[lang][key]) || pageDict['en'][key] || key;
    const showSurveysTpStatus = (type) => {
      let obj = {
        "Open": "Live",
        "Hold": "On Hold",
        "Wait": "Ids Awaited",
        "Close": "End",
        "Test": "Test",
      };
      return obj[type] ?? "";
    }
    return (
      <>
        <GridContainer>
          <div className='w-100 mb-3'>
            <CardHeader color="primary">
              <div className="d-flex align-items-center justify-content-between">
                <h4>{t("Surveys")}</h4>
                <div>
                  <Button
                    onClick={() => {
                      return this.setState({
                        formType: MODAL_TYPES.CREATE,
                      });
                    }}
                    variant="primary"
                    size="sm"
                    className="mx-1"
                  >
                    <FontAwesomeIcon icon={['fas', 'plus']} className="mr-2" />
                    {t("Create")}
                  </Button>
                </div>
              </div>
            </CardHeader>
          </div>
        </GridContainer>

        <div className="jumbotron bg-white p-3 border shadow-sm">
          <div className='mb-3'>{t("Filter")}</div>

          <form>
            <div className="row">
              <div className="col">
                <label htmlFor='publishDate'>{t("Start Date")}</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="select date"
                  name="publishDate"
                  value={filters.publishDate}
                  onChange={this.handleFilterChange}

                />
              </div>
              <div className="col">
                <label htmlFor='pmName'>{t("PM Name")}</label>
                <select
                  style={{
                    width: '100%',
                    display: 'block',
                    height: '40px',
                    lineHeight: '1.5',
                    color: '#495057',
                    backgroundColor: '#fff',
                    backgroundClip: 'padding-box',
                    border: '1px solid #ced4da',
                    borderRadius: '5px',
                    transition:
                      'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                  }}
                  name='pmName'
                  id='pmName'
                  value={filters.pmName}
                  onChange={this.handleFilterChange}
                >
                  <option value=''>{t("--Choose--")}</option>
                  {this.state.pmRespoOpts.length > 0 ? this.state.pmRespoOpts.map((item, index) => (
                    <option key={"pmRespoOpts" + index} value={item.label}>{item.label}</option>
                  )) : ''}
                </select>
              </div>
              <div className="col">
                <label htmlFor='expiryDate'>{t("End Date")}</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="select date"
                  name="expiryDate"
                  value={filters.expiryDate}
                  min={filters.publishDate || undefined}
                  onChange={this.handleFilterChange}

                />
              </div>
              <div className="col">
                <label htmlFor='surveyType'>{t("Type")}</label>
                <select
                  style={{
                    width: '100%',
                    display: 'block',
                    height: '40px',
                    lineHeight: '1.5',
                    color: '#495057',
                    backgroundColor: '#fff',
                    backgroundClip: 'padding-box',
                    border: '1px solid #ced4da',
                    borderRadius: '5px',
                    transition:
                      'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                  }}
                  name='surveyType'
                  id='type'
                  required
                  value={filters.surveyType}
                  onChange={this.handleFilterChange}
                >
                  <option value='' disabled>{t("--Choose--")}</option>
                  <option value='Test'>{t("Test")}</option>
                  <option value='Hold'>{t("On Hold")}</option>
                  <option value='Open'>{t("Live")}</option>
                  <option value='Wait'>{t("Ids awaited")}</option>
                  <option value='Close'>{t("End")}</option>
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label htmlFor='projectname'>{t("Project Name")}</label>
                <input type="text"
                  className="form-control"
                  placeholder={t("Enter...")}
                  name="projectname"
                  value={filters.projectname}
                  onChange={this.handleFilterChange}
                />
              </div>
              <div className="col">
                <label htmlFor='projectId'>{t("Project ID")}</label>
                <input type="text"
                  className="form-control"
                  placeholder={t("Enter...")}
                  name="projectId"
                  value={filters.projectId}
                  onChange={this.handleFilterChange}
                />
              </div>
              <div className="col">
                <label htmlFor='client'>{t("Client Name")}</label>
                <input type="text" name="client" className="form-control" placeholder={t("Enter...")} value={filters.client}
                  onChange={this.handleFilterChange} />
              </div>
              <div className="col">
                  <label htmlFor='country'>{t("Country")}</label>
                  <select
                      style={{
                          width: '100%',
                          display: 'block',
                          height: '40px',
                          lineHeight: '1.5',
                          color: '#495057',
                          backgroundColor: '#fff',
                          backgroundClip: 'padding-box',
                          border: '1px solid #ced4da',
                          borderRadius: '5px',
                          transition:
                              'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                      }}
                      name='country'
                      id='country'
                      value={filters.country}
                      onChange={this.handleFilterChange}
                  >
                      <option value=''>{t("--Choose--")}</option>
                      {this.state.countryOpts && this.state.countryOpts.length > 0 ? this.state.countryOpts.map((item, index) => (
                          <option key={"countryOpts" + index} value={item.value}>{item.label}</option>
                      )) : ''}
                  </select>
              </div>
            </div>
          </form>

          <div className="jumbotron bg-white p-1 mt-2 shadow-sm">
            <button type="button" className="btn btn-success" onClick={() => this.applyFilters()}>{t("Filter Surveys")}</button>
            <button type="button" className="btn btn-info ml-1" onClick={() => this.handleExport()}>{t("Export")}</button>
            <button type="button" className="btn btn-danger ml-1" onClick={() => this.clearFilter()}>{t("Clear Filter")}</button>
          </div>


        </div>

        <div className="jumbotron bg-white p-3 border shadow-sm">
          <Alert variant="danger" show={this.state.status === PageStatus.Error}>
            {this.state.error}
          </Alert>

          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Show when={this.state.status === PageStatus.Loaded}>
            <Show when={this.state.formType === MODAL_TYPES.CREATE}>
              <Form
                show={this.state.formType === MODAL_TYPES.CREATE}

                onClose={() => this.setState({
                  formType: MODAL_TYPES.NONE,
                })}
                onRefresh={() => this.fetchList(true)}
                onSubmit={(id) => {
                  this.fetchList(true);
                  this.setState({
                    formType: MODAL_TYPES.DETAILS, id: id,
                  });
                }}
              />
            </Show>

            <Show when={!this.state.filteredData.length}>
              <Alert variant="info" show={!this.state.filteredData.length}>
                {t("No data is available")}
              </Alert>
            </Show>

            <Show when={!!this.state.filteredData.length}>
              <Show when={this.isShowDetailModal()}>
                <Details
                  id={this.state.id}

                  onClose={() => this.setState({
                    formType: MODAL_TYPES.NONE,
                    id: null,
                  })}
                  onUpdate={() => {
                    this.setState({
                      formType: MODAL_TYPES.UPDATE,
                    });
                  }}
                  onDelete={(id) => {
                    this.fetchList(true);
                    this.setState({
                      formType: MODAL_TYPES.NONE,
                      id: null,
                    });
                  }}
                />
              </Show>

              <Show when={this.state.formType === MODAL_TYPES.UPDATE}>
                <Form
                  show={this.state.formType === MODAL_TYPES.UPDATE}
                  id={this.state.id}

                  onClose={() => this.setState({
                    formType: MODAL_TYPES.NONE,
                    id: null,
                  })}
                  onRefresh={() => this.fetchList(true)}
                  onSubmit={(id) => {
                    this.fetchList(true);
                    this.setState({
                      formType: MODAL_TYPES.DETAILS, id: id,
                    });
                  }}
                />
              </Show>
              <div className='mb-2'>
                <ShowDataAccording2PageSize
                  currentPageSize={pageSize}
                  currentPage={currentPageNumber}
                  sendPageSize={this.handlePageSizeChange}
                  showTotalData={totalResponseData}
                  sendLastPage={totalResponsePages}
                />
              </div>
              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999' }}>
                {this.state.loading && (
                  <img style={{ height: "415px", }}
                    src="../loadernew.gif"
                    alt="Loading..."
                  />
                )}
              </div>
              <Table responsive size="sm" bordered>
                <thead>
                  <tr>
                    <th>{t("Project Name")}</th>
                    <th>{t("Project Id")}</th>
                    <th>{t("Country")}</th>
                    <th>{t("Survey Unique Id")}</th>
                    <th>{t("Client")}</th>
                    <th>{t("Status")}</th>
                    <th>{t("Complete Points")}</th>
                    <th>{t("PM")}</th>
                    <th>{t("Start Date")}</th>

                  </tr>
                </thead>

                <tbody>
                  {
                    groupSurveysByParent(this.state.filteredData).map((parent) => (
                      <Fragment key={parent.id}>
                        <tr style={parent.hasChildren ? { backgroundColor: '#f8f9fa' } : {}}>
                          <td className="text-start">
                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                              {parent.hasChildren ? (
                                <span
                                  onClick={() => this.toggleParent(parent.id)}
                                  style={{ cursor: 'pointer', marginRight: '6px', display: 'inline-block', transition: 'transform 0.2s', transform: this.state.expandedParents[parent.id] ? 'rotate(90deg)' : 'rotate(0deg)', flexShrink: 0, marginTop: '2px' }}
                                >&#9654;</span>
                              ) : (
                                <span style={{ display: 'inline-block', width: '16px', flexShrink: 0 }}></span>
                              )}
                              <button
                                type="button"
                                className="bg-transparent text-primary p-0 border-0 text-start d-block"
                                style={{ whiteSpace: "normal" }}
                                onClick={() => {
                                  this.setState({
                                    formType: MODAL_TYPES.DETAILS,
                                    id: parent.id,
                                  });
                                }}
                              >
                                <div
                                  style={{ textAlign: "left", display: "block", whiteSpace: "normal" }}
                                  dangerouslySetInnerHTML={{
                                    // getSurveyDisplayName keys on the row's own parentid, so an
                                    // ORPHAN child (parent not on this page) rendered through this
                                    // parent branch still gets its childProjectName. A true parent
                                    // resolves to projectname exactly as before.
                                    __html: getSurveyDisplayName(parent) || "Title",
                                  }}
                                ></div>
                              </button>
                            </div>
                          </td>
                          <td>{parent.projectId}</td>
                          <td>{parent.country}</td>
                          <td>{parent.uniqueid}</td>
                          <td>{parent.client}</td>
                          <td>{showSurveysTpStatus(parent.surveyType)}</td>
                          <td>—</td>
                          <td>{parent.pmName}</td>
                          <td>{moment(parent.publishDate).format('MM/DD/YYYY')}</td>
                        </tr>
                        {this.state.expandedParents[parent.id] && parent.children.map((child) => (
                          <tr key={child.id} style={{ backgroundColor: '#f0f4f8' }}>
                            <td className="text-start" style={{ paddingLeft: '36px' }}>
                              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <span style={{ color: '#999', marginRight: '6px', flexShrink: 0 }}>&#9492;</span>
                                <button
                                  type="button"
                                  className="bg-transparent text-primary p-0 border-0 text-start d-block"
                                  style={{ whiteSpace: "normal", fontSize: '0.92em' }}
                                  onClick={() => {
                                    this.setState({
                                      formType: MODAL_TYPES.DETAILS,
                                      id: child.id,
                                    });
                                  }}
                                >
                                  <div
                                    style={{ textAlign: "left", display: "block", whiteSpace: "normal" }}
                                    dangerouslySetInnerHTML={{
                                      __html: getSurveyDisplayName(child) || "Title",
                                    }}
                                  ></div>
                                </button>
                              </div>
                            </td>
                            <td>{child.projectId}</td>
                            <td>{child.country}</td>
                            <td>{child.uniqueid}</td>
                            <td>{child.client}</td>
                            <td>{showSurveysTpStatus(child.surveyType)}</td>
                            <td>{isPanelCountryByName(child.country) ? child.ceggPoints : '—'}</td>
                            <td>{child.pmName}</td>
                            <td>{moment(child.publishDate).format('MM/DD/YYYY')}</td>
                          </tr>
                        ))}
                      </Fragment>
                    ))
                  }
                </tbody>

              </Table>
              <div>
                <PaginationNumbering
                  currentPage={currentPageNumber}
                  returnPagenumber={this.handlePageNumberChange}
                  showTotalData={totalResponseData}
                  sendLastPage={totalResponsePages}
                />
              </div>
            </Show>
          </Show>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedCountry: state.adminUser.adminUser.selectedCountry,
});

const Surveys = withRouter(connect(mapStateToProps)(SurveysComponent));
export { Surveys };
